import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'walletTransfer',
    routes: [
        {
            path: '/wallet-transfer',
            name: 'walletTransfer',
            meta: { requiresAuth: true },
            component: overridable('WalletTransferPage', () => import(/* webpackChunkName: "wallet-transfer" */ './views/WalletTransferPage.vue'))
        }
    ],
    contributes: {
        'profile.links': [
            {
                key: 'walletTransfer',
                order: 30,
                to: '/wallet-transfer',
                iconPath: 'M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3',
                label: 'walletTransfer.title',
                desc: 'walletTransfer.manageWalletTransfer'
            }
        ]
    }
});
